/* istanbul ignore file */

import React from 'react';

const RedirectMessage = () => {
  return <div>Redirecting...</div>;
};

export default RedirectMessage;
